<template>
  <div class="teaching-arrange-setting-default">
    <slot></slot>
    <div v-if="useDefault"
         class="use-default">
      <div class="tip">使用默认配置中</div>
      <div class="append">
        <el-button size="mini"
                   type="text"
                   @click="setUseCustom">自定义配置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeachingArrangeSettingDefault',
  props: {
    value: Boolean
  },
  computed: {
    useDefault: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    setUseCustom () {
      this.useDefault = false
    }
  }
}
</script>

<style lang="scss">
  .teaching-arrange-setting-default {
    position: relative;
    & > .use-default {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 999;
      background-color: #f0f2f5;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      & > .tip {
        color: #909399;
        font-size: 12px;
      }
      & > .append {
        margin-top: 10px;
        .el-button {
          padding: 0;
        }
      }
    }
  }
</style>
